export default {
    stateLocations: {
        ActiveMediaQuery: "ActiveMediaQuery",
        Conversation: {
            stagedInputWatches: [
                "LiveChat.StagedEvent",
              ],        
            receivedResponseWatches: [
                "Conversation.ReceivedResponse",
                "Conversation.UploadHistory.ReceivedResponse",
                "History.ReceivedResponse",
                "LiveChat.BeginChatExtStaging.ReceivedResponse",
                "LiveChat.SendMessageExtStaging.ReceivedResponse",
                "LiveChat.GetMessagesExtStaging.ReceivedResponse",
                "LiveChat.GetMessagesExtStaging.ProcessResponse",
                "LiveChat.GetChatStatusStaging.ReceivedResponse",
                "LiveChat.UserDisconnectStaging.ProcessResponse",
                "LiveChat.UserDisconnectStaging.ReceivedResponse",
                "Window.initializationData.receivedResponse",
                "OutputMasking.ReceivedResponse",
            ],
            ReportingEvent: {
                Base: "ReportingEvent",
            },

            // live chat foundation
            Base: 'Conversation',
            processedResponse: 'ProcessedResponse',
            responseProcessing: 'ResponseProcessing',

        },
        Initialization: {
            channelSet:"channelSet",
        },
        PersistentStorage: {
            watches: {
                NITAlme: [
                    "Conversation.AccessKey",
                    "Conversation.Channel",
                    "Conversation.Language",
                    "Conversation.SessionId",
                    "Conversation.UserId",
                    "Conversation.IsActiveSession",
                    "Window.Position",
                    "Window.Size",
                    "Window.IsMinimized",
                    "Window.disableLaunchEvents",
                    "Window.advocacyVariables.launchedProactively",
                    "Window.advocacyVariables.messagesGiven.birthAdoptChklstUrl",
                    "Window.advocacyVariables.messagesGiven.addrChangeChklstUrl",
                    "Window.advocacyVariables.messagesGiven.divorceChklstUrl",
                    "Window.advocacyVariables.advocacyConfigData",
                    "Window.productPayload.advocacyConfigData",
                    "Window.productPayload.payloadSaved",
                    "Window.productPayload.customIVA.IVAName",
                    "Window.productPayload.customIVA.IVAAvatar",
                    "Window.productPayload.generalConfigData.userHasChat",
                    "Window.urlLastLaunchedFrom",
                    "Window.initializationData.multiTenantId",
                    "Window.UDPVars",
                    "Conversation.IsActiveSession",
                    "LiveChat.LastSeenIndex",
                    "LiveChat.SessionState",
                    "Survey.metaData",
                    "Survey.reason",
                    "Survey.comment",    
                ],
                NITOfferData: [
                    "Offers",
                ],
            },
        },
        Window: {
            IsEmbedded: "IsEmbedded",
            disableLaunchEvents: "disableLaunchEvents",
            platformId: "platformId",
            stagedEvent: "StagedEvent",
            currentTree: "CurrentTree",
            urlLastLaunchedFrom: "urlLastLaunchedFrom",
            Input: {
                CurrentPlaceholder: "CurrentPlaceholder",
                NeedsFocus: "NeedsFocus",
            },  
            initializationData: {
                Base: "initializationData",
                receivedResponse: {
                    Base:"receivedResponse",
                    response:{
                        Base:"response",
                        initDataRetrieved:"initDataRetrieved",
                    },
                },
                initDataRetrieved: "initDataRetrieved",
                advocacyConfigData: "advocacyConfigData",
                multiTenantId: "multiTenantId",
                uuid: "uuid",
                metadata:{
                    Base: "metadata",
                    roleId: "roleId",
                },
            },
            InlineSurveyLinks: {
                Base: "InlineSurveyLinks",
                shouldDisable: "shouldDisable",
            },
            productPayload: {
                Base: "productPayload",
                completeResponseMap: "completeResponseMap",
                payloadSaved: "payloadSaved",
                accessKey: "AccessKey",
                advocacyConfigDataLocation: "advocacyConfigData",
                generalConfigData: {
                    Base: "generalConfigData",
                    userHasChat: "userHasChat",
                    roleId: "roleId",
                    ivaSearchEnabled: "ivaSearchEnabled",
                },
                customIVA: {
                    Base:"customIVA",
                    IVAName: "IVAName",
                    IVAAvatar: "IVAAvatar",
                },
            },
            advocacyVariables: {
                Base: "advocacyVariables",
                launchedProactively: "launchedProactively",
                messagesGiven: {
                    Base: "messagesGiven",
                    birthAdoptChklstUrl: "birthAdoptChklstUrl",
                    addrChangeChklstUrl: "addrChangeChklstUrl",
                    divorceChklstUrl: "divorceChklstUrl",
                },
                advocacyConfigData: "advocacyConfigData",
            },
            UDPVars:{
                Base: "UDPVars",
                UUID:"UUID",
            },
        },
        Advocacy: {
            Base: "Advocacy",
        },
        OutputMasking: {
            Base : "OutputMasking",
            receivedResponse: "ReceivedResponse",
            savedUdpData : "SavedUdpData",
            responseStorage:"ResponseStorage",
            ApiCallRunning:"ApiCallRunning",
        },
        productInfo: {
            Base: "productInfo",
            productInfoFunctionName: "NITSubmitProductInfo",
            productPayload: "productPayload",
        },
        GenerateNewSession: {
            Base: "GenerateNewSession",
            generateNewSessionFlag: "GenerateNewSessionFlag",
            resetEnabled: "resetEnabled",
        },
        LiveChat: {
            ProcessedResponse: "ProcessedResponse",
            SurveyUrl: "SurveyUrl",
            IsChatAvailable: "IsChatAvailable",
            DisplayMessageReceivedWait: "DisplayMessageReceivedWait",
            SendMessageExtStaging: {
                Base: "SendMessageExtStaging",
                ReceivedResponse: "ReceivedResponse",
            },
            AvailabilityStaging: {
                Base: "AvailabilityStaging",
            },
            MinimizedCount: "MinimizedCount",

            // live chat foundation
            Base: 'LiveChat',
            operatorData: 'OperatorData',
            operatorTyping: 'OperatorTyping',
            sessionState: 'SessionState',
            stagedEvent: 'StagedEvent',

        },
        History: {
            Base: 'History',
            initializeCompleted: 'InitializeCompleted',
            Messages: 'HistoryMessages',
        },
        Offers: {
            Base: 'Offers',
            offersAvailable: 'OffersAvailable',
            offersProvided: 'OffersProvided',
            offerData: 'OfferData',
        },
    },
};


// WEBPACK FOOTER //
// ./settings/state-locations.ts